export default 'USER_CANCELED_NEW_RECORDING';
